import React, {Component} from 'react';
import {
  StyleSheet,
  Text,
  View,
  Image,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import PropTypes from 'prop-types';
import colors from '../HelperClasses/AppColor';
import toolTip from './../assets/toolTip.png';

import tableStyle from '../StyleSheets/TableCommonStyleSheet';
import {Gradient} from 'react-gradient';
import HelperVideoView from '../Component/HelperVideoView';
import TableCommonStyleSheet from '../StyleSheets/TableCommonStyleSheet';
import BackBtnView from '../Component/BackBtnView';
import SaveButton from '../Component/SaveButton';
import AppConstants from '../Constants/AppConstants';
import {withRouter} from '../wrappers/withRouter';
import CloseBtnView from '../Component/CloseBtnView';
import SecondryButton from '../Component/SecondryButton';
import {ThemeContext} from '../HelperClasses/ThemeContext';
import ListingsHeaderV2 from '../MainListing/ListingsHeaderV2';
import LocaleContext from '../Localization/LocaleContext';

const windowHeight = Dimensions.get('window').height;
const windowWidth = Dimensions.get('window').width;
let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

class HeaderView extends Component {
  static contextType = ThemeContext;
  static propTypes = {
    title: PropTypes.string,
    backBtn: PropTypes.func,
    showBackBtn: PropTypes.bool,
    saveBtn: PropTypes.func,
    toolTipBtn: PropTypes.func,
    saveBtnTitle: PropTypes.string,
    showSaveBtn: PropTypes.bool,
    showToolTipBtn: PropTypes.bool,
    toolTipBtn: PropTypes.func,
    showHelperVideoBtn: PropTypes.bool,
    helperVideoBtnAction: PropTypes.func,
    btnDeActive: PropTypes.bool,
    deActiveBtnAction: PropTypes.func,
    isClose: PropTypes.bool,
    secondary_btnAction: PropTypes.func,
    secondary_btnTitle: PropTypes.string,
    secondary_showBtn: PropTypes.bool,
    secondary_btnDeActive: PropTypes.bool,
    secondary_deActiveBtnAction: PropTypes.func,
    extra_buttons: PropTypes.any,
    viewControls: PropTypes.any,
    searchControl: PropTypes.any,
    isBeta: PropTypes.bool,
  };

  showSaveBtnRender = () => {
    return (
      <SaveButton
        saveBtn={this.props.saveBtn}
        showSaveBtn={this.props.showSaveBtn}
        deActiveBtnAction={this.props.deActiveBtnAction}
        btnDeActive={this.props.btnDeActive}
        saveBtnTitle={this.props.saveBtnTitle}
      />
    );
  };

  showSecondaryBtnRender = () => {
    return (
      <SecondryButton
        btnAction={this.props.secondary_btnAction}
        btnTitle={this.props.secondary_btnTitle}
        showBtn={this.props.secondary_showBtn}
        btnDeActive={this.props.secondary_btnDeActive}
        deActiveBtnAction={this.props.secondary_deActiveBtnAction}
      />
    );
  };

  renderToolTip = () => {
    return (
      <TouchableOpacity
        style={{
          display: this.props.showToolTipBtn ? 'flex' : 'none',
          width: 20,
          height: 20,
          marginRight: 10,
        }}
        onPress={this.props.toolTipBtn}>
        <Image
          style={{height: 20, width: 20, marginTop: 2}}
          resizeMode="center"
          source={toolTip}
        />
      </TouchableOpacity>
    );
  };
  renderHelperVideoBtn = () => {
    return (
      <View style={{display: this.props.showHelperVideoBtn ? 'flex' : 'none'}}>
        <HelperVideoView
          helperVideoBtnAction={() => this.props.helperVideoBtnAction()}
        />
      </View>
    );
  };
  render() {
    return (
      <ListingsHeaderV2
        simple={true}
        titleArea={
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <TouchableOpacity
              style={[
                styles.backBtnBackViewStyle,
                {display: this.props.showBackBtn ? 'none' : 'flex'},
              ]}
              onPress={
                this.props.backBtn
                  ? this.props.backBtn
                  : () => this.props.navigate(-1)
              }>
              {this.props.isClose ? <CloseBtnView /> : <BackBtnView />}
            </TouchableOpacity>
            <Text
              style={[
                TableCommonStyleSheet.titleTextStyle,
                {
                  color: this.context?.colors?.primaryText ?? colors.AppTitleBlack,
                  marginLeft: this.props.showBackBtn ? 0 : 16,
                },
              ]}>
              {this.props.title}
            </Text>
            {this.props.isBeta && (
              <Text
                style={{
                  color: colors.AppNewGreen,
                  fontSize: 14,
                  fontStyle: 'italic',
                  marginLeft: 8,
                }}>
                <LocaleContext.Consumer>{context => context?.translate?.('common.beta', '(beta)') || '(beta)'}</LocaleContext.Consumer>
              </Text>
            )}
            {this.renderToolTip()}
          </View>
        }
        tableControls={this.renderHelperVideoBtn()}
        viewControls={this.props.viewControls}
        searchControl={this.props.searchControl}
        actionControl={
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
            {this.props.extra_buttons && this.props.extra_buttons}
            {this.props.secondary_showBtn && <this.showSecondaryBtnRender />}
            <this.showSaveBtnRender />
          </View>
        }
      />
    );
  }
}

export default withRouter(HeaderView);

const styles = StyleSheet.create({
  headerView: {
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: 'white',
    flexDirection: 'row',
    borderRadius: 10,
    borderColor: colors.SimonGray,
    borderWidth: 1,
    minHeight: 60,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 0,
    flexWrap: 'wrap',
  },
  backBtnBackViewStyle: {
    height: 40,
    width: 40,
    marginLeft: 20,
    backgroundColor: colors.UltraGreen,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
  },
  backBtnStyle: {
    height: 15,
    width: 15,
  },
  saveBtnStyle: {
    backgroundColor: colors.AppNewGreen,
    height: 40,
    width: 140,
    borderRadius: 5,
    marginRight: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
